import { AutogenLayoutCollectionCallHistory } from "./autogen/AutogenLayoutCollectionCallHistory";

export class CollectionCallHistory extends AutogenLayoutCollectionCallHistory {
    onLoad() {
        this.textboxGroupBy.selectedItem = this.textboxGroupBy.items[0];
    }

    includeCallDetailChanged() {
        if (this.checkboxIncludeCallDetail?.checked == true) {
            this.checkboxPrintItemsWithBalanceOnly.enabled = true;
        } else {
            this.checkboxPrintItemsWithBalanceOnly.enabled = false;
            this.checkboxPrintItemsWithBalanceOnly.checked = false;
        }
    }

    sortByChanged() {
        if (this.textboxGroupBy?.selectedItem?.displayValue == "Customer Code") {
            this.checkboxPageBreak.caption = "Page Break After Each Customer";

        } else if (this.textboxGroupBy?.selectedItem?.displayValue == "Assigned User") {
            this.checkboxPageBreak.caption = "Page Break After Each Assigned User";

        } else if (this.textboxGroupBy?.selectedItem?.displayValue == "Caller") {
            this.checkboxPageBreak.caption = "Page Break After Each Caller";
        } else {
            this.checkboxPageBreak.caption = "Page Break After Each Customer";
        }
    }
}
